import { render, staticRenderFns } from "./EventProfile.vue?vue&type=template&id=37b9a454&scoped=true&"
import script from "./EventProfile.vue?vue&type=script&lang=js&"
export * from "./EventProfile.vue?vue&type=script&lang=js&"
import style0 from "./EventProfile.vue?vue&type=style&index=0&id=37b9a454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9a454",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VChip,VIcon})
